import styled from '@emotion/styled';

const BackgroundBlurringOverlay = styled('section')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  backdropFilter: 'blur(40px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  ':not(:hover) .button-wrapper:not(:focus-within)': {
    marginTop: 0,
    opacity: 0,
  },
});

export default BackgroundBlurringOverlay;
